var ControlType;
(function (ControlType) {
  ControlType["ACCENT"] = "accent";
  ControlType["POSITIVE"] = "positive";
  ControlType["NEGATIVE"] = "negative";
})(ControlType || (ControlType = {}));
var Priority;
(function (Priority) {
  Priority["PRIMARY"] = "primary";
  Priority["SECONDARY"] = "secondary";
  Priority["TERTIARY"] = "tertiary";
})(Priority || (Priority = {}));

export { ControlType, Priority };
//# sourceMappingURL=control.mjs.map
